import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

type TData = {
  header: string;
  message: string;
};

@Component({
  standalone: true,
  selector: 'contact-support-tips',
  templateUrl: './contact-support-tips.component.html',
  styleUrls: ['./contact-support-tips.component.scss'],
  imports: [CSButtonComponent, CSIconButtonComponent, CommonModule, PipesModule],
})
export class ContactSupportTipsComponent implements OnInit {
  // 從Dialog傳入的數據
  protected dialogData: TData | null = null;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) dialogData: TData | null,
    @Optional() public dialogRef: MatDialogRef<ContactSupportTipsComponent>,
    private appService: AppService,
  ) {
    this.dialogData = dialogData;
    if (dialogData) {
      // 如果是通過Dialog打開，使用Dialog數據
      this.header = dialogData.header;
      this.message = dialogData.message;
    }
  }

  header: string = '';
  message: string = '';

  ngOnInit() {}

  onConfirm(): void {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  contactSupport() {
    this.appService.toOnLineService$.next(true);
  }
}
